module.exports = __webpack_public_path__ + "assets/img/2_729_big.8e1b5a22.jpg";